import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddressDialogData } from '../../common';
import { HeaderComponent } from '../header.component';

@Component({
    selector: 'nphs-user-select-address-dialog',
    templateUrl: './select-address-dialog.component.html',
    styleUrls: ['./select-address-dialog.component.scss'],
    standalone: false
})
export class SelectAddressDialogComponent implements OnInit {

  selectedAddress: any;
  addressForm = new UntypedFormGroup({
    account: new UntypedFormControl(''),
    deliveryAddressList: new UntypedFormControl('', [Validators.required])
  });

  get deliveryAddressList(){
    return this.addressForm.get('deliveryAddressList')
  }

  constructor(
    public addressDialogRef: MatDialogRef<HeaderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddressDialogData
  ) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
  }

  onSubmit() {
    if (!this.addressForm.valid) {
      return false;
    } else {
      this.addressDialogRef.close(this.selectedAddress);
    }
  }

}